/* eslint semi:0 */
/**
 * XHR wrapper. LEGACY, DON'T USE.
 */
import { warn } from '../application/console'

const networkProvider = {
  fetchFromServer: window.fetch,

  parseJsonResponse(response, condition) {
    return condition ? JSON.parse(response) : response
  },

  jsonp(url, callback) {
    const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random())
    const script = document.createElement('script')
    const { body } = document
    window[callbackName] = function jsonpCallback(data) {
      delete window[callbackName]
      body.removeChild(script)
      callback(data)
    }
    script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName
    body.appendChild(script)
  },

  ajaxRequest(config) {
    let { url, method, data = {}, params, type } = config
    const isJson = type === 'json'
    const xhr = new XMLHttpRequest()
    xhr.timeout = 6e4
    return new Promise(function xhrPromise(resolve, reject) {
      xhr.onerror = xhr.ontimeout = e => reject({ e, rejectionReason: e.type })
      // eslint-disable-next-line complexity, consistent-return
      xhr.onreadystatechange = function xhrOnReadyStateChangeHandler(e) {
        const { readyState, status: httpStatus, responseText } = xhr
        if (readyState === XMLHttpRequest.DONE) {
          if (httpStatus === 200) {
            return resolve(networkProvider.parseJsonResponse(responseText, isJson))
          }
          let rejectionReason = null
          if (isJson) {
            try {
              rejectionReason = JSON.parse(responseText)
            } catch (ex) {
              const { message } = ex
              warn('ajaxRequest rejection: expected type "json", got something unparseable', {
                xhr,
                responseText,
                httpStatus,
                ex,
                message,
              })
              rejectionReason = message
            }
          }
          reject({
            url,
            message: `ajaxRequest to '${url}' failed!`,
            rejectionReason,
            httpStatus,
            responseText,
          })
        }
      }
      method = method.toUpperCase()
      url = params ? `${url}${networkProvider.jsonToQueryString(params)}` : url
      xhr.open(method, url, true)
      let payload
      if (method === 'POST' && isJson) {
        xhr.setRequestHeader('Content-Type', 'application/json')
        payload = JSON.stringify(data)
      }
      xhr.send(payload)
    })
  },
  jsonToQueryString(json) {
    return (
      '?' +
      Object.keys(json)
        .map(function encodeKeyValue(key) {
          let value = json[key]
          value = [undefined, null].includes(value) ? '' : '=' + encodeURIComponent(value)
          return encodeURIComponent(key) + value
        })
        .join('&')
    )
  },
  getJson(url) {
    return networkProvider.ajaxRequest({ method: 'GET', url, type: 'json' })
  },
  safeRequest(config) {
    try {
      return networkProvider
        .ajaxRequest(config)
        .catch(ex => warn('[safeRequest failed]:', { message: ex.message, ex }))
    } catch (ex) {
      const { message } = ex
      return Promise.resolve(
        warn(`safeRequest failed for the following reason: '${message}'`, { ex, message, config })
      )
    }
  },
}

export default networkProvider



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/networkProvider.js